import { ImageLoader } from "@src/helpers/ImageLoader";
import { ImageCanvasWrapper } from "@src/saunaparts/ImageCanvasWrapper";
import ImageResolution from "@src/saunaparts/ImageResolution";

import { LayerImageRepository, Sauna } from "..";
import { Layer } from "./Layer";

export class StoveLayer implements Layer
{
    layerImageRepository:LayerImageRepository;
    sauna:Sauna;
    constructor(layerImageRepository:LayerImageRepository,sauna:Sauna)
    {
        this.layerImageRepository= layerImageRepository;
        this.sauna= sauna;
    }
    Render(desiredResolution: ImageResolution): Promise<HTMLCanvasElement> {
        let path = this.layerImageRepository.getStoveLayer(this.sauna.Model, this.sauna.benchProductLine, this.sauna.stoveLight, this.sauna.stove, desiredResolution);
        return new ImageLoader(path).Load().then(i => new ImageCanvasWrapper(i, desiredResolution).getCanvas()).catch(() => document.createElement("canvas"));
    }
}